<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M10.5,792.5c0-2.7-1.17-5.31-2.93-7.07S3.2,782.5,0.5,782.5c-2.7,0-5.31,1.17-7.07,2.93s-2.93,4.37-2.93,7.07
	c0,2.7,1.17,5.31,2.93,7.07c1.76,1.76,4.37,2.93,7.07,2.93c2.7,0,5.31-1.17,7.07-2.93C9.33,797.81,10.5,795.2,10.5,792.5L10.5,792.5
	z M6.28,798.29c-1.53,1.53-3.46,2.39-5.78,2.39c-2.33,0-4.25-0.87-5.79-2.39c-1.53-1.53-2.39-3.46-2.39-5.79
	c0-2.33,0.87-4.25,2.39-5.79c1.53-1.53,3.46-2.39,5.79-2.39c2.33,0,4.25,0.87,5.78,2.39c1.53,1.53,2.39,3.46,2.39,5.79
	C8.68,794.83,7.81,796.75,6.28,798.29L6.28,798.29z M-0.43,794.02v3.64h1.82v-3.64H-0.43z M-0.43,787.35v3.64h1.82v-3.64H-0.43z
	 M-4.66,793.4h3.64v-1.82h-3.64V793.4z M2.01,793.4h3.64v-1.82H2.01V793.4z"/>
</svg>

</template>